import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { OPENING_MODE_VALUES, OpeningMode, frenchOpeningMode } from '@gozoki/api-types';

export interface OpeningModePickerProps {
    setOpeningMode: (value: OpeningMode) => void;
    currentValue: OpeningMode;
}

export const OpeningModePicker = ({ setOpeningMode, currentValue }: OpeningModePickerProps) => {
    const handleChange = (event: SelectChangeEvent<string>) => {
        setOpeningMode(event.target.value as OpeningMode);
    };

    return (
        <FormControl fullWidth>
            <InputLabel>Mode</InputLabel>
            <Select label="Mode" onChange={handleChange} value={currentValue}>
                {OPENING_MODE_VALUES.map((openingMode, index) => (
                    <MenuItem key={index} value={openingMode}>
                        {frenchOpeningMode[openingMode]}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
